<button mat-icon-button (click)="open()">
	<mat-icon
		class="icon-size-6 -mt-0.5"
		[svgIcon]="'heroicons_outline:magnifying-glass'"
	></mat-icon>
</button>
